import React, { useEffect, useState } from "react";
import ModalComponent from "../../components/modalComponent";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import TextInput from "../../components/textInput";
import ButtonComponent from "../../components/button";
import FileUpload from "../../components/fileUpload/FileUpload";
import DatePickerInput from "../../components/datepickerInput";

const UploadDocumentModal = ({ open, onClose, onSubmitFunction, rowData }) => {
  const [uploadedFile, setUploadedFile] = useState(null);
  const [uploadedFileEn, setUploadedFileEn] = useState(null);
  const [uploadedFilePt, setUploadedFilePt] = useState(null);

  const schema = yup.object().shape({
    alertDate: yup
      .date()
      .nullable()
      .typeError("La fecha es obligatoria")
      .required("La fecha es obligatoria"),
    title: yup.string().required("El título es obligatorio"),
    message: yup.string().required("La descripción es obligatoria"),
    file: yup
      .mixed()
      .nullable()
      .test("fileType", "Solo se permite PDF", (value) => {
        if (!value || typeof value !== "object" || !value[0]) return true;
        return value[0].type === "application/pdf";
      })
      .test("fileSize", "El archivo no debe superar los 5MB", (value) => {
        if (!value || typeof value !== "object" || !value[0]) return true;
        return value[0].size <= 5 * 1024 * 1024;
      }),
    titleEn: yup.string().required("El título es obligatorio"),
    messageEn: yup.string().required("La descripción es obligatoria"),
    fileEn: yup
      .mixed()
      .nullable()
      .test("fileType", "Solo se permite PDF", (value) => {
        if (!value || typeof value !== "object" || !value[0]) return true;
        return value[0].type === "application/pdf";
      })
      .test("fileSize", "El archivo no debe superar los 5MB", (value) => {
        if (!value || typeof value !== "object" || !value[0]) return true;
        return value[0].size <= 5 * 1024 * 1024;
      }),
    titlePt: yup.string().required("El título es obligatorio"),
    messagePt: yup.string().required("La descripción es obligatoria"),
    filePt: yup
      .mixed()
      .nullable()
      .test("fileType", "Solo se permite PDF", (value) => {
        if (!value || typeof value !== "object" || !value[0]) return true;
        return value[0].type === "application/pdf";
      })
      .test("fileSize", "El archivo no debe superar los 5MB", (value) => {
        if (!value || typeof value !== "object" || !value[0]) return true;
        return value[0].size <= 5 * 1024 * 1024;
      }),
});

  const formatDate = (date) => {
    if (!date|| date === "") return null;
    const d = new Date(date);
    const year = d.getFullYear();
    const month = `${d.getMonth() + 1}`.padStart(2, "0");
    const day = `${d.getDate()}`.padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const {
    control,
    handleSubmit,
    reset,
    register,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      alertDate: formatDate(rowData?.alertDate),
      title: rowData?.title || "",
      message: rowData?.message || "",
      file: null,
      titleEn: rowData?.titleEn || "",
      messageEn: rowData?.messageEn || "",
      fileEn: null,
      titlePt: rowData?.titlePt || "",
      messagePt: rowData?.messagePt || "",
      filePt: null,
    },
  });

  useEffect(() => {
    if (open) {
      reset({
        alertDate: formatDate(rowData?.alertDate),
        title: rowData?.title || "",
        message: rowData?.message || "",
        file: null,
        titleEn: rowData?.titleEn || "",
        messageEn: rowData?.messageEn || "",
        fileEn: null,
        titlePt: rowData?.titlePt || "",
        messagePt: rowData?.messagePt || "",
        filePt: null,
      });
      setUploadedFile(null);
      setUploadedFileEn(null);
      setUploadedFilePt(null);
    }
  }, [open, rowData, reset]);

  const handleFileUpload = (fileData) => {
    setUploadedFile(fileData);
  };
  const handleFileUploadEn = (fileData) => {
    setUploadedFileEn(fileData);
  };

  const handleFileUploadPt = (fileData) => {
    setUploadedFilePt(fileData);
  };


  const handleFormSubmit = (formData) => {
  const path = uploadedFile?.path || rowData?.path;
  const pathEn = uploadedFileEn?.path || rowData?.pathEn;
  const pathPt = uploadedFilePt?.path || rowData?.pathPt;

  const somePathProvided = !!path || !!pathEn || !!pathPt;
  const allPathsProvided = !!path && !!pathEn && !!pathPt;

  if (somePathProvided && !allPathsProvided) {
    alert("Si carga uno de los archivos, debe cargar los tres (español, inglés y portugués).");
    return; 
  }

  const payload = {
    id: rowData?.id || 0,
    alertDate: formData.alertDate,
    title: formData.title,
    message: formData.message,
    path,
    titleEn: formData.titleEn,
    messageEn: formData.messageEn,
    pathEn,
    titlePt: formData.titlePt,
    messagePt: formData.messagePt,
    pathPt,
  };

  console.log("payload*****", payload);
  onSubmitFunction(payload);
  onClose();
};

  return (
    <ModalComponent
      open={open}
      onClose={onClose}
      onSubmit={handleSubmit(handleFormSubmit)}
      title={rowData ? "Editar alerta" : "Crear nueva alerta"}
    >
      <form onSubmit={handleSubmit(handleFormSubmit)}>
        <div className="mt-10">
          <DatePickerInput
            name="alertDate"
            control={control}
            label="Fecha de la alerta"
          />
        </div>
        <div className="mt-10">
          <TextInput name="title" label="Título Español" control={control} />
        </div>
        <div className="mt-10">
          <TextInput name="message" isTextArea= {true} label="Mensaje Español" control={control} />
        </div>
        <div className="HContainer mt-10">
          <FileUpload
            name="file"
            register={register}
            accept="application/pdf"
            label="Seleccionar archivo PDF en Español"
            error={errors.file?.message}
            existingFile={rowData?.path}
            onChange={handleFileUpload}
          />
        </div>
        <div className="mt-10">
          <TextInput name="titleEn" label="Título Ingles" control={control} />
        </div>
        <div className="mt-10">
          <TextInput name="messageEn" isTextArea= {true} label="Mensaje Ingles" control={control} />
        </div>
        <div className="HContainer mt-10">
          <FileUpload
            name="fileEn"
            register={register}
            accept="application/pdf"
            label="Seleccionar archivo PDF en Ingles"
            error={errors.file?.message}
            existingFile={rowData?.pathEn}
            onChange={handleFileUploadEn}
          />
        </div>
        <div className="mt-10">
          <TextInput name="titlePt" label="Título Portugues" control={control} />
        </div>
        <div className="mt-10">
          <TextInput name="messagePt" isTextArea= {true} label="Mensaje Portugues" control={control} />
        </div>
        <div className="HContainer mt-10">
          <FileUpload
            name="filePt"
            register={register}
            accept="application/pdf"
            label="Seleccionar archivo PDF en Portugues"
            error={errors.file?.message}
            existingFile={rowData?.pathPt}
            onChange={handleFileUploadPt}
          />
        </div>
        <div className="HContainer j-center mt-20">
          <ButtonComponent
            type="submit"
            backgroundColor="#F6C079"
            textColor="#000000"
            width="160px"
          >
            Guardar
          </ButtonComponent>
        </div>
      </form>
    </ModalComponent>
  );
};

export default UploadDocumentModal;
